package com.essntl.features.service.data.supabase.supplierservice

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single
internal class SupplierServiceSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<SupplierServiceDto> {
    override val tableName: String = "supplier_service"
}
